module.exports = __webpack_public_path__ + "img/dotted.25718463.svg";